<div class="form-group" *ngIf="attribute?.values?.length">
  <label
    for="{{ createAttributeIdForConfigurator(attribute) }}"
    class="cx-visually-hidden"
  >
    {{
      'configurator.a11y.listbox'
        | cxTranslate
          : {
              count: attribute.values?.length,
            }
    }}
  </label>

  <select
    id="{{ createAttributeIdForConfigurator(attribute) }}"
    class="form-control"
    [ngClass]="{
      'cx-required-error-msg ': (showRequiredErrorMessage$ | async),
    }"
    [formControl]="attributeDropDownForm"
    [cxFocus]="{ key: attribute.name }"
    (change)="onSelect(attributeDropDownForm.value)"
    [attr.aria-describedby]="createAttributeUiKey('label', attribute.name)"
  >
    <option
      *ngFor="let item of attribute.values"
      [label]="getLabel(false, item.valueDisplay, undefined, item)"
      [selected]="item.selected"
      [value]="item.valueCode"
      [attr.aria-label]="
        isRetractValue(item.valueCode)
          ? ('configurator.a11y.forAttribute'
            | cxTranslate
              : { value: item.valueDisplay, attribute: attribute.label })
          : item.valuePrice && item.valuePrice?.value !== 0
            ? ('configurator.a11y.selectedValueOfAttributeFullWithPrice'
              | cxTranslate
                : {
                    value: item.valueDisplay,
                    attribute: attribute.label,
                    price: item.valuePriceTotal?.formattedValue ?? 0,
                  })
            : ('configurator.a11y.selectedValueOfAttributeFull'
              | cxTranslate
                : { value: item.valueDisplay, attribute: attribute.label })
      "
      [value]="item.valueCode"
    >
      {{ getLabel(false, item.valueDisplay, undefined, item) }}
    </option>
  </select>
</div>

<cx-configurator-attribute-product-card
  *ngIf="isNotRetractValue()"
  id="{{
    createAttributeValueIdForConfigurator(attribute, selectedValue.valueCode)
  }}"
  (handleDeselect)="onSelect(RETRACT_VALUE_CODE)"
  [productCardOptions]="extractProductCardParameters()"
>
</cx-configurator-attribute-product-card>

<div *ngIf="withQuantity" class="cx-attribute-level-quantity-price">
  <cx-configurator-attribute-quantity
    (changeQuantity)="onChangeQuantity($event, attributeDropDownForm)"
    [quantityOptions]="extractQuantityParameters(attributeDropDownForm)"
  ></cx-configurator-attribute-quantity>
  <cx-configurator-price
    [formula]="extractPriceFormulaParameters()"
  ></cx-configurator-price>
</div>
